// extracted by mini-css-extract-plugin
module.exports = {"bestSeller":"BestSeller_bestSeller__XLcGW","topRight":"BestSeller_topRight__bfuC3","bottomLeft":"BestSeller_bottomLeft__cFrGc"};